export default {
    CM_FWU_CONNECT_TIMEOUT: 300,
    CM_CONNECT_TIMEOUT: 15,
    CM_CONNECT_ERROR_TIMEOUT: 30,
    CM_RECONNECT_TIMEOUT: 2,
};
